/****************************************************
 ** functions.js - Main javascript function library **
 ****************************************************/

/* Init actions */
function changeOnSubmit() { // disable enter key form submission (chrome, safari)
  //oldsubmit = document.forms[0].onsubmit;
  document.forms[0].action = "javascript:return false();";
  /*document.forms[0].onsubmit = function() {
    //oldsubmit();
    return false;
  }*/
}
/* webos function overrides */
function getTag(id) {
  if (document.getElementById)
    return document.getElementById(id);
  else if (document.all)
    return document.all[id];
  else
    return null;
} 
$(document).ready(function() {
  changeOnSubmit(); 
});

function addDependent(a, b) {}
var WebOS = {
  Client: {
    setPageSubject: function(objOid) {},
    registerFieldDependency: function(toid, topic, accessName, name, label, dependency) {}
  }
};


/* Detect IE version and load extra css */
// $.browser={};
// $.browser.msie=false;
// $.browser.version=0;
// if(navigator.userAgent.match(/MSIE ([0-9]+)\.[0-9]?/) || !!navigator.userAgent.match(/Trident\/.*rv:[0-9]+\.[0-9]?/)){ ///MSIE ([6-8]+)\./
//   $.browser.msie=true;
//   $.browser.version = !!navigator.userAgent.match(/Trident\/.*rv:[0-9]+\.[0-9]?/) ? "MSIE 11.0" : navigator.userAgent.match(/MSIE [0-9]+\.[0-9]?/)[0];
//   if ($.browser.version.replace("MSIE ", "") < 9) {
//     var cssNode = document.createElement('link');
//     cssNode.type = 'text/css';
//     cssNode.rel = 'stylesheet';
//     cssNode.href = urlPrefix + templateHome + 'css/browsers/ie8.css';
//     cssNode.media = 'screen';
//     $(cssNode).insertAfter("head link[href *= 'css/site']");   
//   }
// }

// Desktop Breakpoint
var query = Modernizr.mq('(min-width: 1232px)');

/* Email and Print Functions */
var VCARD_CONFIRMATION = "";

function mailTo(email) {
  window.parent.location = "mailto:" + email;
  /* var disclaimPopup = $('#email_disclaimer_popup');
  if (query) {
    disclaimPopup.dialog({
      title: "PLEASE READ BEFORE SENDING AN E-MAIL",
      width: 540,
      closeOnEscape: true,
      closeText: "close",
      dialogClass: "email_disclaimer popup_dialog",
      resizable: false,
      open: function() {
        $("button").blur();
      },
      buttons: {
        "Accept": function() {
          $(this).dialog("close");
          window.parent.location = "mailto:" + email;
        },
        "Cancel": function() {
          $(this).dialog("close");
        }
      }
    });
  } else {
    disclaimPopup.html(disclaimPopup.html().replace(/<p>/g, "").replace(/<\/p>/g, "\n\n"));
    var fmtText = disclaimPopup.text().replace("\"Accept\"", "\"OK\"");
    var defConfirm = confirm(fmtText);
    if (defConfirm)
      window.parent.location = "mailto:" + email;
  } */

}

function vCard(path) {
  if (VCARD_CONFIRMATION === "" || confirm(VCARD_CONFIRMATION)) {
    window.parent.location = path;
  }
}

// Check all divs in narrow page column (if exists) to see if anything is drawn to the page, if not then hide it (allowing the wide column to be 100% width)
function hideEmptyAreas() {
  $("#content td.top-col, #content td.narrow-col").each(function() {
    var totalHeight = 0;
    var temp;
    var pb;

    $(this).find("div").each(function() {
      if ((this.id + "").indexOf("portlet") >= 0) { // one of the main portlets
        temp = this.offsetHeight;
        if (temp > 0) {
          pb = parseInt($(this).css("paddingBottom"));
          temp = (temp >= pb ? (temp - pb) : temp);
          totalHeight += temp;
        }
      }
    });

    if (totalHeight <= 0) {
      $(this).css("display", "none");

      /*if(colNames[j] === "narrow-col") { // make wide col fill 100%
        var wideCol = getElementsByClassName("wide-col", "td", getTag("contentBody"));

        if(wideCol.length > 0) { // if wide col exists
          wideCol[0].className = wideCol[0].className.replace("wide-col", "");
        }
      }*/
    }
    if ($(this).hasClass("top-col")) { // change top-col to wide-col
      this.className = this.className.replace("top-col", "wide-col");
    }
  });

  $("#content td.top-col, #content td.wide-col, #content td.narrow-col").each(function() {
    var newStyle = "";
    if ((temp = $(this).prev()) && (temp.length === 0 || temp.css("display") === "none")) { // previous sibling doesn't exist or is empty
      newStyle += ((newStyle === "" ? "" : " ") + "padding-left: 0px !important;");
    }
    if ((temp = $(this).next()) && (temp.length === 0 || temp.css("display") === "none")) { // next sibling doesn't exist or is empty
      newStyle += ((newStyle === "" ? "" : " ") + "padding-right: 0px !important;");
    }
    if (newStyle !== "") { // new style to apply
      $(this).find(".portalPageArea").attr("style", newStyle);
    }
  });
}


/**
 * Create a cookie with the given name and value and other optional parameters.
 *
 * @example $.cookie('the_cookie', 'the_value');
 * @desc Set the value of a cookie.
 * @example $.cookie('the_cookie', 'the_value', { expires: 7, path: '/', domain: 'jquery.com', secure: true });
 * @desc Create a cookie with all available options.
 * @example $.cookie('the_cookie', 'the_value');
 * @desc Create a session cookie.
 * @example $.cookie('the_cookie', null);
 * @desc Delete a cookie by passing null as value. Keep in mind that you have to use the same path and domain
 *       used when the cookie was set.
 *
 * @param String name The name of the cookie.
 * @param String value The value of the cookie.
 * @param Object options An object literal containing key/value pairs to provide optional cookie attributes.
 * @option Number|Date expires Either an integer specifying the expiration date from now on in days or a Date object.
 *                             If a negative value is specified (e.g. a date in the past), the cookie will be deleted.
 *                             If set to null or omitted, the cookie will be a session cookie and will not be retained
 *                             when the the browser exits.
 * @option String path The value of the path atribute of the cookie (default: path of page that created the cookie).
 * @option String domain The value of the domain attribute of the cookie (default: domain of page that created the cookie).
 * @option Boolean secure If true, the secure attribute of the cookie will be set and the cookie transmission will
 *                        require a secure protocol (like HTTPS).
 * @type undefined
 *
 * @name $.cookie
 * @cat Plugins/Cookie
 * @author Klaus Hartl/klaus.hartl@stilbuero.de
 */

/**
 * Get the value of a cookie with the given name.
 *
 * @example $.cookie('the_cookie');
 * @desc Get the value of a cookie.
 *
 * @param String name The name of the cookie.
 * @return The value of the cookie.
 * @type String
 *
 * @name $.cookie
 * @cat Plugins/Cookie
 * @author Klaus Hartl/klaus.hartl@stilbuero.de
 */
jQuery.cookie = function(name, value, options) {
  if (typeof value !== 'undefined') { // name and value given, set cookie
    options = options || {};
    if (value === null) {
      value = '';
      options.expires = -1;
    }
    var expires = '';
    if (options.expires && (typeof options.expires === 'number' || options.expires.toUTCString)) {
      var date;
      if (typeof options.expires === 'number') {
        date = new Date();
        date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
      } else {
        date = options.expires;
      }
      expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
    }
    // CAUTION: Needed to parenthesize options.path and options.domain
    // in the following expressions, otherwise they evaluate to undefined
    // in the packed version for some reason...
    var path = options.path ? '; path=' + (options.path) : '';
    var domain = options.domain ? '; domain=' + (options.domain) : '';
    var secure = options.secure ? '; secure' : '';
    document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
  } else { // only name given, get cookie
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = jQuery.trim(cookies[i]);
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }
};

/*Pop ip video button */
$(function() {
 $('#play-button').click(function(e){
            	e.preventDefault();
              console.log("");
							openPopupMediaPlayer();		
 });            
	});
/*
 *  Open Media Popup Player
 */
 function openPopupMediaPlayer(){

  videoPopup = $('.media_player_popup').length === 0 ? $("<div>", {"class": "media_player_popup"}) : $('.media_player_popup');
  videoPopup.html("");
  var browserHeight = $(window).height();

  $.ajax({
    url: aurl = urlPrefix + "webportal/serveContent.v?src=ajax-media-video-popup-content&pooid=",
    success: function(data) {
      videoPopup.html(data).dialog({
        closeOnEscape: true,
        closeText: "close",
        dialogClass: "popup_dialog",
        resizable: false,
        modal: true,
        width: 'auto',
        open: function(){
          $("button").blur();
          $('.ui-widget-overlay').css({"opacity" : 0, "height" : browserHeight}).animate({opacity: 0.7}, 500);
        },
        close: function(){$(this).html("")}                   
      });
    }
  }); 
 }
 
/* Page options builder  */
(function($) {
  $.fn.buildPageOptions = function() {
    return this.each(function() {
      $(this).find(".icon_printHtml").click(function() {
        window.print();
        return false;
      });
    });
  };
})(jQuery);


/* * * * * * * * * * * * * * * * * * * *
 * Get content from ajax call (widget)
 *
 */
(function($) {
  // build default config search
  $.fn.getContentAjax = function(opts) {
    // var options = opts;
    var options = $.extend({
      ajaxWidget: null,
      container: null,
      pageObjPoid: null,
      mode: 'replace',
      spinLoading: true
    }, opts);

    var contentContainer = options.container,
      widgetName = options.ajaxWidget,
      pooid = options.pageObjPoid,
      mode = options.mode;
    var container = contentContainer ? $(contentContainer) : $(this);
    var acUrl = urlPrefix + "webportal/serveContent.v?src=" + widgetName + (pooid ? "&pooid=" + pooid : "");
    var extraParam = '';
    $.map(options, function(v, k) {
      if (k !== 'ajaxWidget' && k !== 'pageObjPoid' && k !== 'mode' && k !== 'spinLoading')
        extraParam += "&" + k + "=" + v;
    });
    acUrl += extraParam;

    var request = $.ajax({
      url: acUrl,
      dataType: "html",
      beforeSend: function() {
        if (options.spinLoading) {
          var sp_spinner = $("<div>", {
            "id": "sp_spinner",
            "class": "icon-spin3 animate-spin"
          });
          container.css('position', 'relative');
          container.append(sp_spinner);
        }
      },
      complete: function() {
        if (options.spinLoading)
          $("#sp_spinner").remove();
      }
    });

    request.done(function(data) { // ajax call succeeded
      if (mode === 'replace') {
        container.html(data);
      } else {
        container.append(data);
      }
    });

    request.fail(function(jqXHR, textStatus) { // ajax call failed
      console.log("AJAX REQUEST FAILED: " + textStatus);
    });

  };

})(jQuery);


/* 
 * Build Lazy Load Function (Not Search Result)
 *
 */

(function($) {
  $.fn.buildLazyload = function(opts) {
    // var options = opts;
    var options = $.extend({
      folderName: null,
      sortedBy: null,
      ajaxWidget: null,
      listDiv: null,
      totalNum: 0,
      numPerPage: 10
    }, opts);

    var paFolder = options.folderName,
      paWidget = options.ajaxWidget,
      sortedBy = options.sortedBy,
      listCtn = options.listDiv ? $(options.listDiv) : $(this),
      numPerPage = parseInt(options.numPerPage),
      numOfPage = 0;
    listCtn = listCtn.is("ul") ? listCtn : listCtn.find("ul").get(0);

    var totalNum = parseInt(options.totalNum); // total number of items
    var aurl;
    var toHoldLoading = false;

    // bind to scrolling event
    $(window).scroll(function() {
      if ($(window).scrollTop() + $(window).height() >= listCtn.offset().top + listCtn.height() - 40 && !toHoldLoading) { // scroll to container's bottom

        numOfPage = $(listCtn).data("pno"); // get current paging number
        if (!numOfPage) {
          numOfPage = 1;
          $(listCtn).data("pno", 1);
        }
        var nextPos = numOfPage * numPerPage;

        if (nextPos < totalNum) { // load the next page items

          numOfPage += 1;
          aurl = urlPrefix + "webportal/serveContent.v?src=" + paWidget + "&numOfPage=" + numOfPage + "&numPerPage=" + numPerPage + "&folder=" + paFolder + (sortedBy ? "&sortedBy=" + sortedBy : "");

          var extraParams = window.location.search.substring(1);
          if (extraParams)
            aurl += "&" + extraParams;

          // start ajax call
          var request = $.ajax({
            url: aurl,
            dataType: "html",
            beforeSend: function() {
              toHoldLoading = true;
              var sp_spinner = $("<div id=\"load_spinner\" class=\"loading_spin\"><div class=\"rect1\"></div><div class=\"rect2\"></div><div class=\"rect3\"></div><div class=\"rect4\"></div><div class=\"rect5\"></div></div>");
              sp_spinner.appendTo(listCtn);
              // hide footer
              $("#footer").hide();
            },
            complete: function() {
              toHoldLoading = false;
              $("#load_spinner").remove();
            }
          });

          request.done(function(data) { // ajax call succeeded
            listCtn.append(data);
            $(listCtn).data("pno", numOfPage);

          });

          request.fail(function(jqXHR, textStatus) { // ajsx call failed
            console.log("Request failed: " + textStatus);
          });

        }

      }
    });

  }
})(jQuery);

/* 
 * Build Lazy Load Search Result Function
 *
 */
(function($) {

  $.fn.buildSRLazyLoad = function(opts) {
    var options = $.extend({
      sectionName: null,
      sectionOid: null,
      numPerPage: 10
    }, opts);

    var sectionName = options.sectionName,
      sectionOid = options.sectionOid,
      numPerPage = options.numPerPage,
      totalPages = options.totalPages;

    // var listContainerDiv = $("#searchresult_group_" + sectionName); 
    var listContainerDiv = $(this);
    var srList = listContainerDiv.is("ul") ? listContainerDiv : listContainerDiv.find("ul").get(0);
    var toHoldLoading = false;

    var extraParam = '';
    $.map(options, function(v, k) {
      if (k !== 'sectionName' && k !== 'sectionOid' && k !== 'numPerPage')
        extraParam += "&" + k + "=" + v;
    });

    // bind to scrolling event
    $(window).scroll(function() {
      if ($(window).scrollTop() + $(window).height() >= listContainerDiv.offset().top + listContainerDiv.height() - 40 && !toHoldLoading) { // scroll to container's bottom

        var pageNo = listContainerDiv.data("vmpNo");
        if (pageNo < totalPages) { // ajax call fetchSearchPage.v to get next page of search results
          // $.cpPaging.loadPageContent(pageNo + 1, sectionName, sectionOid, numPerPage, true);
          var url = document.location.href;
          // var paramSep = url.indexOf( "?" );
          // var urlParams = url.substring( paramSep );    
          var newPage = pageNo + 1;
          var spRequest = $.ajax({
            //url: urlPrefix + 'websearch/fetchSearchPage.v' + urlParams + '&guid=' + sectionOid + '&vetemplateId=none' + '&page=' + newPage + '&numPerpage=' + numPerPage + (isPast ? "&isPast=1" : (isUpcoming ? "&isUpcoming=1" : "")) + ( listContainerDiv.wosSortString ? listContainerDiv.wosSortString : "" ) + ($.cpPaging.testMode ? "&rand=" + parseInt(Math.random()*99999999) : ""),
            url: urlPrefix + "webportal/serveContent.v?src=ajax-website-search-result-lazy-load&guid=" + sectionOid + "&page=" + newPage + "&hitsPerPage=" + numPerPage + "&urlPrefix=" + urlPrefix + extraParam,
            dataType: "html",
            beforeSend: function() {
              toHoldLoading = true;
              var sp_spinner = $("<div id=\"load_spinner\" class=\"loading_spin\"><div class=\"rect1\"></div><div class=\"rect2\"></div><div class=\"rect3\"></div><div class=\"rect4\"></div><div class=\"rect5\"></div></div>");
              sp_spinner.appendTo(srList);
              // hide footer
              $("#footer").hide();

            },
            complete: function() {
              toHoldLoading = false;
              $("#load_spinner").remove();

              // display bio disclaimer
              if ($(".atty_name.not_admitted").length)
                $(".atty_disclaimer").show();

              $("#footer").show();
            }
          });

          spRequest.done(function(data) { // ajax call succeeded
            $(srList).append(data);
            listContainerDiv.data("vmpNo", pageNo + 1);
            if (sectionOid.indexOf("people") > 0 && options.showIcons)
              $(srList).buildBioPreview();
          });

          spRequest.fail(function(jqXHR, textStatus) { // ajsx call failed
            console.log("Search Paging Ajax Request failed: " + textStatus);
          });
        }

      }
    })

  };

})(jQuery);



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Build Michael Best & Friedrich LLP Search Form (beautify select dropdown)
 *
 */
(function($) {
  // build default config search
  $.fn.buildMHSearch = function(params) {

    var $thisForm = $(this);
    // drop down list customization
    if (query)
      $thisForm.find(".inputSelect select").betterSelect();

    // datepicker
    $thisForm.find(".s_dateWrapper").each(function() {
      var dateInput = $(this).find(".s_dateInput input");
      dateInput.datepicker({
        //dateFormat : "dd/mm/y",
        showOn: "button",
        buttonText: "<i class=\"icon_datePicker icon-calendar\"></i>"
      });
      // $(this).find(".s_dateButton .icon_datePicker").click(function(){
      //   dateInput.focus();
      // });
    });

    // reset action for betterSelect
    $thisForm.find(".search_btn > a[fhtype='resetbutton']").click(function() {
      $thisForm.find(".betterSelect").each(function() {
        $(this).find(".selectBox").text($(this).find(".dropDown li:first span").text());
      });
    });

    return this.each(function() {
      $(this).buildSearchHandler(params);
    });
  };

})(jQuery);


/* * * * * * * * * * * * * * * * * * * * * * *
 * People Search Result - Preview
 *
 */

(function($) {

  $.fn.buildBioPreview = function(opts) {
    /* default options */
    var options = $.extend({}, opts);
    var $container = $(this).parent();
    $container.find('.bio_icon.atty_preview').each(function() {

      var $btn = $(this),
        bioUrl = $btn.attr('href'),
        $previewText = $(this).parent().find('.bio_preview_text'),
        $previewWrapper;

      function closePreview() {
        $previewWrapper.find('.bio_preview_text,.read_more_link').remove();
        $container.find('.bio_icon.atty_preview').removeClass('disabled');
        $container.find('.bio_inline_wrapper').removeClass('disabled');
        $previewWrapper.hide();
      }

      if ($('#bio_preview_popup').length) {
        $previewWrapper = $('#bio_preview_popup');
      } else {
        $previewWrapper = $('<div>', {
          "id": "bio_preview_popup"
        });
        var $closeBtn = $("<div class=\"close icon-cancel\">Close</div>").appendTo($previewWrapper);
        $closeBtn.on('click', closePreview);
        // $previewWrapper.hide().appendTo($container);
        $previewWrapper.hide().appendTo('body');
      }

      $btn.on('click', function(e) {
        e.preventDefault();
        if (!$btn.hasClass('disabled')) {
          $container.find('.bio_icon.atty_preview').addClass('disabled');
          $container.find('.bio_inline_wrapper').not($(this).closest('.bio_inline_wrapper')).addClass('disabled');
          $previewWrapper.append($previewText);
          $('<div class="read_more_link"><a href="' + bioUrl + '" class="full_bio_link">FULL BIO</a></div>').appendTo($previewWrapper);
          $previewWrapper.show().offset({
            top: ($previewWrapper.outerHeight() > ($('footer').offset().top - $btn.offset().top - $btn.outerHeight()) ? ($btn.offset().top - $previewWrapper.outerHeight() - 1) : ($btn.offset().top + $btn.outerHeight() + 1))
          });
        }
      });

      // click outside to close popup
      $(document).mouseup(function(e) {
        var container = $('#bio_preview_popup');
        if (!container.is(e.target) // if the target of the click isn't the container...
          && container.has(e.target).length === 0) // ... nor a descendant of the container
        {
          closePreview();
        }
      });
    });

  };

})(jQuery);


/* * * * * * * * * * * * * 
 *  Practice List Toggle
 *
 */

(function($) {

  $.fn.buildPracticeToggle = function(opts) {
    /* default options */
    // var options = $.extend({}, opts);
    var $piList = $(this);

    function expandList(obj) {
      var arrow = $(obj),
        parentLi = $(obj).parent().parent(),
        sublist = parentLi.find('.pil_list');

      arrow.switchClass('icon-plus', 'icon-minus');
      sublist.slideToggle(300, function() {
        parentLi.switchClass('fold', 'expand');
      });

    }

    function collapseList(obj) {
      var arrow = $(obj),
        parentLi = $(obj).parent().parent(),
        sublist = parentLi.find('.pil_list');

      arrow.switchClass('icon-minus', 'icon-plus');
      sublist.slideToggle(300, function() {
        parentLi.switchClass('expand', 'fold');
      });
    }



    $piList.find('.pi_toggle_arrow').on('click', function() {
      if ($(this).hasClass('icon-plus'))
        expandList(this);
      else if ($(this).hasClass('icon-minus'))
        collapseList(this);
      $('a.pi_toggle_expand, a.pi_toggle_collapse').css('font-weight', '300');
    });

    $('a.pi_toggle_expand').on('click', function(e) {
      e.preventDefault();
      $(this).css('font-weight', '500');
      $('a.pi_toggle_collapse').css('font-weight', '300');
      $piList.find('.pi_toggle_arrow.icon-plus').each(function() {
        expandList(this);
      });
    });
    $('a.pi_toggle_collapse').on('click', function(e) {
      e.preventDefault();
      $(this).css('font-weight', '500');
      $('a.pi_toggle_expand').css('font-weight', '300');
      $piList.find('.pi_toggle_arrow.icon-minus').each(function() {
        collapseList(this);
      });
    });
  };

})(jQuery);

/* * * * * * * * * * * * * * * * * * * * * * *
 * Details Page Read More Function
 *
 */

(function($) {

  $.fn.buildMoreLess = function(opts) {
    /* default options */
    var options = $.extend({}, opts);
    if($('.professionals_details_wrapper').length > 0){
      $('.minHeightDiv').css('min-height',$('.professionals_details_wrapper').height()+75);
    }
    $(this).each(function() {
       var $content = $(this),
       contentHtml = $content.html(),
       $rmBtn = $content.find('button.read-more-marker').first();
       $rmBtn.text("").addClass("more_less_icon icon-plus");
       if ($rmBtn.length) {
        var rmBtnOuterHtml = $('<div>').html($rmBtn.clone()).html();
        var hiddenText;
        if ($rmBtn.parent()[0] != $content) {
          var $rmParent = $rmBtn.parent().first();
          var rpHtml = $rmParent.html(),
              splitIdx = rpHtml.indexOf(rmBtnOuterHtml) + rmBtnOuterHtml.length;
          $rmParent.html(rpHtml.substring(0, splitIdx) + "<span class=\"more_text\">" + rpHtml.substring(splitIdx) + "</span>");
          $rmParent.nextAll().addClass("more_text");
          } else {
          $rmBtn.nextAll().addClass("more_text");
        }
        var $showMoreBtn = $content.find('button.read-more-marker');
        var $showLessBtn = $('<button type="button" class="more_less_icon icon-minus">');
        $showLessBtn.on('click', function() {
          $content.find('.more_text').hide();
          $showMoreBtn.show();
        });
        $showLessBtn.appendTo($content.find('.more_text').last());        
        $showMoreBtn.on('click', function(e) {
          e.preventDefault();
          var $showMoreBtn = $(this);
          $showMoreBtn.hide();
          $content.find('.more_text').show();
        });
      }
    });
  };
})(jQuery);

/* People details page */
$(function() {
  $('.tm_more_link').on('click',function(){  
    if ($(this).hasClass('more')) {
      $(this).switchClass('more', 'less');
      $('.hidden').removeClass('hidden'); 
      $(this).text("[less]");   
    } 
    else{
      $(this).switchClass('less', 'more');
      $(this).text("[more]");
      $('.item').addClass('hidden');
    }
    if($('.professionals_details_wrapper').length > 0){  
            $('.minHeightDiv').css('min-height',$('.professionals_details_wrapper').height()+75);               
          }
    }); 
});
/*Industries Practices details pages */
$(function() {
  $('.tm_exp_more_link').on('click',function(){  
    if ($(this).hasClass('more')) {
      $(this).switchClass('more', 'less');
      $('.hidden').removeClass('hidden'); 
      $(this).text("[less]");   
    } 
    else{
      $(this).switchClass('less', 'more');
      $(this).text("[more]");
      $('.item').addClass('hidden');
    }
    if($('.professionals_details_wrapper').length > 0){  
            $('.minHeightDiv').css('min-height',$('.professionals_details_wrapper').height()+75);               
          }
    }); 
});
/* * * * * * * * * * * * * * * * * * * * * * *
 * Details Page Content Expand/Collapse Function
 *
 */ 

(function($) {   

  $.fn.buildExpandCollapse = function(opts) { 
    /* default options */
    var options = $.extend({}, opts);

    $(this).find('.expand-collapse-block').each(function() {
      var $header = $(this).find('h1,h2,h3').first(),
        $toggleText = $header.nextAll();

      $toggleText.wrapAll('<div class="toggle_text"></div>');
      var $toggleWrapper = $toggleText.parent();
      $toggleWrapper.hide();

      $header.addClass('toggle_header icon-plus').on('click', function(e) {
        e.preventDefault();
        $toggleWrapper.slideToggle(300);
        if ($(this).hasClass('icon-plus')) {
          $(this).switchClass('icon-plus', 'icon-minus');
        } else {
          $(this).switchClass('icon-minus', 'icon-plus');
        }
      });
    });

  };

})(jQuery);


/* * * * * * * * * * * * * * *
 *  Side Column List Toggle
 *
 */

(function($) {

  $.fn.buildSideColToggle = function(opts) { 
    $(this).find('.side_col_title:not(.contact_section)').each(function() {  
      $(this).on('click', function() { 
        var sclTitle = $(this),
          scWrapper = $(this).parent(),
          sclBody = $(this).next();
        if (scWrapper.hasClass('fold')) { 
          sclBody.slideToggle(300, function() {
            if($('.professionals_details_wrapper').length > 0){
              $('.minHeightDiv').css('min-height',$('.professionals_details_wrapper').height()+75);
            }
            scWrapper.switchClass('fold', 'expand');
            
          });
        } else {
          sclBody.slideToggle(300, function() { 
            scWrapper.switchClass('expand', 'fold');
            
          });
        }
      });
    });

  };

})(jQuery);



/* * * * * * * * * * * * * * *
 * Select dropdown Beautifier 
 *
 */

(function($) {

  $.fn.betterSelect = function(options) {
    options = $.extend({
      // render : function(option){
      //     return $('<li>',{
      //         html : option.text()
      //     });
      // },
      'className': ''
    }, options);

    var closeDropdown = function() {
      $(this).parent().find(".betterSelect .dropDown").hide();
    };
    return this.each(function() {

      // The "this" points to the current select element:

      var select = $(this);
      var selectBoxContainer = $('<div>', {
        // width   : select.outerWidth(),
        'class': 'betterSelect',
        'html': '<div class="selectBox"></div>'
      });

      var dropDown = $('<ul>', {
        'class': 'dropDown'
      });
      var selectBox = selectBoxContainer.find('.selectBox');

      // Looping though the options of the original select element
      if (options.className) {
        dropDown.addClass(options.className);
      }
      select.find('option').each(function(i) {
        var option = $(this);
        if (option.is(":selected")) {
          selectBox.html("<span>" + option.text() + "</span>");
        }
        if (option.data('skip')) {
          return true;
        }

        // Creating a dropdown item according to the
        // data-icon and data-html-text HTML5 attributes:
        var li = $('<li>', {
          html: '<span>' + option.text() + '</span>'
        });
        if (option.attr('class'))
          li.attr('class', option.attr('class'));

        li.click(function() {

          selectBox.html(option.text());
          dropDown.trigger('hide');

          // When a click occurs, we are also reflecting
          // the change on the original select element:
          select.val(option.val()).change(); // trigger change event 
          //don't hide submenu flag
          $("#nav_menu").data("shouldOpen", "yes");
          return false;
        });

        dropDown.append(li);
      });

      select.on("change", function() {
        selectBox.html("<span>" + $(this).find(" option:selected").text() + "</span>");
      });

      if (selectBox.html() === "") {
        selectBox.text(select.find('option:first').text());
      }
      selectBoxContainer.append(dropDown.hide());
      select.hide().after(selectBoxContainer);

      // Binding custom show and hide events on the dropDown:
      dropDown.bind('show', function() {

        if (dropDown.is(':animated')) {
          return false;
        }

        // only allow one dropdown open
        if ($(".expanded").length)
          $(".expanded").removeClass("expanded").parent().find(".dropDown").hide();

        selectBox.addClass('expanded');
        dropDown.slideDown("fast");
        if (select.find(" option:selected").val() === "") {
          dropDown.find("li").first().hide();
        } else {
          dropDown.find("li").first().show();
        }

      }).bind('hide', function() {

        if (dropDown.is(':animated')) {
          return false;
        }

        selectBox.removeClass('expanded');
        dropDown.slideUp("fast");

      }).bind('toggle', function() {
        if (selectBox.hasClass('expanded')) {
          dropDown.trigger('hide');
        } else dropDown.trigger('show');
      });

      selectBox.click(function() {
        dropDown.trigger('toggle');
        return false;
      });

      // If we click anywhere on the page, while the
      // dropdown is shown, it is going to be hidden:

      $(document).click(function() {
        dropDown.trigger('hide');
      });

    });
  };

})(jQuery);


/* * * * * * * * * * * * * * * * * * * * * 
 * Build Michael Best & Friedrich LLP Nav
 */
(function($) {

  $.fn.buildMBNav = function() {


    /* site search */
    $("#ssf_wrapper").buildSearchHandler({
      loadUsedValues: true,
      loadFormGroup: "sitesearch"
    });

    /* nav our people search */
    $("#tnp_searchFields").buildMHSearch({
      loadUsedValues: true,
      loadFormGroup: "peoplesearch"
    });

    // Desktop Search Button Function
    if (query) {
      // Site Search Button
      $('.quick_search .ss_search_icon').on('click', function(e) {
        e.preventDefault();
        if ($(this).hasClass('icon-magnifying-glass-browser')) {
          $(this).switchClass('icon-magnifying-glass-browser', 'icon-cancel');
          $('.gsta_search_wrapper').show();
         
        } else {
          $(this).switchClass('icon-cancel', 'icon-magnifying-glass-browser');
          $('.gsta_search_wrapper').hide();
        }
      }); 
      $('.search_text').on('click', function(e){
       e.preventDefault();
        $('.gsta_search_wrapper').show();
      });
      // Initialize Predictive Search 
      $('#ssf_wrapper').buildPredictiveSearchFunc();
    }
    /* cascade dropdown menu initialization */
    var $menu = $("#nav_menu"),
      $piSubmenu = $(".nav_pi_list");
    $piSubmenu.each(function() {
      $(this).data("originalHeight", $(this).height());
    });
 
    $menu.menuAim({
      activate: activateSubmenu,
      deactivate: deactivateSubmenu,
      submenuDirection: 'below',
      exitMenu: hideSubmenu,
      rowSelector: "> li",
      // rowSelector: "> li:not(.ignore_menu)",
      submenuSelector: ".submenu_wrapper"
    });

    // Industries/Practices Vertical Submenu
    $piSubmenu.menuAim({
      activate: activateSubmenu,
      deactivate: deactivateSubmenu,
      exitMenu: hideSubmenu,
      rowSelector: "> li"
    });

    // var DELAY_MS = 0; // delay submenu open/close ms
    var DELAY_SEC = '0.6s'; // delay submenu open/close ms
    var activateMenuTimer, deactivateMenuTimer, exitMenuTimer;

    function activateSubmenu(row) {
      var $row = $(row),
        submenuId = $row.data("submenuId"),
        $submenu = $("#" + submenuId);

      if ($submenu.hasClass('sub_pi_submenu_wrapper'))
        DELAY_SEC = 0; // no delay in vertical submenu

      //Show the submenu
      $submenu.css({
        visibility: 'visible',
        transition: '0s ' + DELAY_SEC
      });
      // Keep the currently activated row's highlighted look
      $row.find("> a").addClass("maintainHover");


    }

    function deactivateSubmenu(row) {
      var $row = $(row),
        submenuId = $row.data("submenuId"),
        $submenu = $("#" + submenuId);

      // clearTimeout(activateMenuTimer);
      if ($submenu.hasClass('sub_pi_submenu_wrapper'))
        DELAY_SEC = 0; // no delay in vertical submenu      
      //Hide the submenu and remove the row's highlighted look
      if (!$submenu.find("select option:selected[value!='']").length) { // if any of search dropdown selected, don't hide menu
        $submenu.css({
          // display: "none"
          visibility: 'hidden',
          transition: '0s ' + DELAY_SEC
        });
      }
      $row.find("> a").removeClass("maintainHover");
    }

    function hideSubmenu(menu) {
      // Hide the submenu and remove the row's highlighted look
      // $(".submenu_wrapper").css("display", "none");   
      if ($("#ui-datepicker-div").is(":visible"))
        return false;
      $(menu).find(".betterSelect .dropDown").hide(); // close all opened dropdown
      $(menu).find("a.maintainHover").removeClass("maintainHover");
      return true;
    }
    
    //Desktop Hamburger icon
    if (query) {
      $('.icon-menu').on('click', function(e) {
       e.preventDefault(); 
       if ($(this).hasClass('icon-menu')) {
       $(this).switchClass('icon-menu', 'icon-cancel');
        $('.navOverlay').show();
       $(this).stop(true,true).fadeOut; 
       } 
       else {
         $('.navOverlay').hide();
         $(this).switchClass('icon-cancel', 'icon-menu');
         $(this).stop(true,true).fadeOut;
       }
      });
    }
      
    /* * * * * * * * * * * * * * 
     *  mobile hamburger menu 
     * * * * * * * * * * * * * */

    $('#mobile_menu_bar').on('click', function() {
      var menu = $(this); 
      //clearTimeout(delayMobileMenu); 
      $('html, body').animate({
        scrollTop: 0
      }, 500); // scroll to top
      menu.toggleClass('active');
     $('.mobile_menu_wrapper').toggle('slide', {
        direction: 'right'
      }, 600);
    });
    //Click Outside to Close Popup
     $(document).mouseup(function(e) {
       var container1 = $('.menu_shape');
       var container2 = $('.mobile_menu_wrapper');
      if ((!container1.is(e.target) && !container2.is(e.target))// if the target of the click isn't the container...
       && container1.has(e.target).length === 0 && container2.has(e.target).length === 0 && $('#mobile_menu_bar').hasClass("active")) // ... nor a descendant of the container
      {
        $('#mobile_menu_bar').removeClass('active');
        $('.mobile_menu_wrapper').hide('slide', {
          direction: 'right'
        }, 600);
         $('.navOverlay').hide();
         $('.mm_cancel_btn').switchClass('icon-cancel', 'icon-menu');
         event.stopPropagation();
      }
    });
  };
})(jQuery);
/* * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Build Munsch Predictive Search
 *
 */
(function($) {

  $.fn.buildPredictiveSearchFunc = function() {
    var $searchBox = $(this);
    /* site search */
    $searchBox.buildSearchHandler({
      loadUsedValues: true,
      loadFormGroup: "sitesearch",
      hideDefValueOnKeyPress: true
    });
    if (!query)
      return;
    // site search typeahead function initialization
    $searchBox.buildTypeAheadHandler({
      cachePrefix: "ssf_",
      priorFolders: "people",
      matchStartOnly: false,
      maxHits: 10,
      choosingItemSubmits: true,
      enableLink: true,
      includeFolderName: true,
      outputFields: ["calcWebsiteUrl", "redirectUrl"],
      additionalTabs: [{
        "label": "people",
        "name": "people",
        "scope": "people",
        "fieldName": "nameLastFirst",
        "fieldPostSort": true,
        "outputFields": ["name", "fullName", "sortName", "calcImageweburl", "email", "office1Direct", "notAdmitted"]
      }],
      overrideResultFormat: typeAheadSearchresultOutput // override result formatting function                     
    });
  };

  //  Overriden TypeAhead search result output html Function
  function typeAheadSearchresultOutput(resultsList, resultBox) {
    // overridden output format
    var resultHtml = "";
    if (resultsList.length == 0) { // empty resultset 
      resultHtml = "No results";
    } else {
      var resultBox = $(resultBox);
      var rowText, rsItem, rUrl;
      var cscope = $(resultBox).find(".ssf_ta_tab.current").data("sscope");
      cscope = cscope == null ? this.scope : cscope;

      if (cscope == "people") {
        var numPerList = (this.cachePrefix === "ssf_" ? 4 : 6);
        resultHtml = buildPeopleSearchResult(resultsList, numPerList);
      } else {
        // show people first, then other sections
        resultsList.sort(function(a, b) {
          return b["folderName"] == "people" && a["folderName"] != "people"
        });

        for (var i = 0; i < resultsList.length; i++) {
          rsItem = resultsList[i];
          rUrl = urlPrefix + rsItem["url"];
          openNew = false;
          // override link for news item
          if (rsItem["calcWebsiteUrl"]) {
            rUrl = rsItem["calcWebsiteUrl"];
            if (rUrl.indexOf("^") === 0) {
              openNew = true;
              rUrl = rUrl.substring(1);
            }
            if (rUrl.indexOf("+") === 0)
              rUrl = urlPrefix + rUrl.substring(1);
          }
          if (rsItem["redirectUrl"])
            rUrl = rsItem["redirectUrl"];
          if (rUrl === "#") {
            rowText = "<div class=\"ssf_ta_rs_item\">" + rsItem["name"] + "</div>";
          } else {
            rowText = "<div class=\"ssf_ta_rs_item\">" +
              "<a " + (openNew ? "target=_blank " : "") + "class=\"ssf_ta_link\" href=\"" + rUrl + "\">" + rsItem["name"] + "</a>" +
              "</div>";
          }
          resultHtml += rowText;
        }
      }

      // inject result html to its wrapper
      $(resultBox).find(".ta_resultsI").html(resultHtml);
      if ($(resultHtml).find(".not_admitted").length)
        $(".ppl_disclaimer").appendTo($(resultBox)).show();
      else
        $(".ppl_disclaimer").hide();
      // display search string and update it immediately
      var $sstr = $(resultBox).find(".ssf_ta_rs_summary");
      if (!$sstr.length) {
        $sstr = $("<div>", {
          "class": "ssf_ta_rs_summary"
        });
        $(resultBox).append($sstr);
      }
      $sstr.html('<div class="read_more_link"><a href="/Search?search=' + resultBox.parent().find("input:eq(0)").val() + '&cpsfg=sitesearch">VIEW ALL</a></div>');

      // build result paging
      //$(resultBox).find(".ta_resultsI .ssf_ta_rs_atty_wrapper").buildTypeAheadResultPaging();

      // var hlJs = window.location.href + "/templates/shared/js/jquery.highlight-search-terms.js";
      // $.getScript(hlJs).done(function() {
      //   console.debug("load = " + hlJs);
      // });            
    }
  }

  function buildPeopleSearchResult(resultsList, numPerList) {
    var rsItem, rowText, resultHtml = "";
    resultHtml += "<div class=\"ssf_ta_rs_atty_wrapper\"><div class=\"ssf_ta_rs_atty_list\">";
    for (var i = 0; i < resultsList.length; i++) {
      rsItem = resultsList[i];
      rowText = "";
      rowText += "<div class=\"ssf_ta_rs_atty\">";

      if (rsItem["calcImageweburl"]) {
        var imgSrc = urlPrefix + rsItem["calcImageweburl"];
        rowText += "<a href=\"" + urlPrefix + rsItem["url"] + "\"><div class=\"ssf_ta_atty_img\"><img src=\"" + imgSrc + "\"/></div></a>";
      } else {
        rowText += "<div class=\"ssf_ta_atty_img atty_img_default\"></div>";
      }

      attyNameFm = rsItem["fullName"];
      var notAdmitted = rsItem["notAdmitted"] && rsItem["notAdmitted"] === "true" ? true : false;
      rowText += "<div class=\"ssf_ta_atty_info_wrapper" + (notAdmitted ? " not_admitted" : "") + "\">" +
        "<a href=\"" + urlPrefix + rsItem["url"] + "\"><span class=\"ssf_ta_atty_name\">" + attyNameFm + "</span></a>" +
        (typeof rsItem["email"] != "undefined" ? "<div class=\"ssf_ta_atty_email\"><a class=\"atty_email_icon\" href='javascript:mailTo(\"" + rsItem["email"] + "\")'>" + rsItem["email"] + "</a></div>" : "") +
        (typeof rsItem["office1Direct"] != "undefined" ? "<div class=\"ssf_ta_atty_phone\">" + rsItem["office1Direct"] + "</div>" : "") +
        "</div>";
      rowText += "</div>";
      resultHtml += rowText;
    }
    resultHtml += "</div></div>";
    return resultHtml;
  }

})(jQuery);

/* * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Build Cookie Consent Popup
 *
 */
(function($) {
  $.fn.cpCookiePopup = function(settings) {
    var COOKIE_NAME = 'CP_COOKIE_LAW_CONSENT';
    var INITIALISED = false;
    var _params = {
      cookiePolicyUrl: '/Privacy-Cookies-Policy',
      popupText: 'We use cookies to make the experience of our website better. By using our website, your consent to the use of cookies is deemed to be given. To understand more about how we use cookies, please see our <a href="/Privacy-Cookies-Policy">Privacy and Cookies Policy</a>.',
      buttonAcceptLabel : 'Accept & Hide Message',
      buttonReadmoreLabel : 'Read&nbsp;more',
      expiresInDays : 30,
      htmlMarkup: null,
      attachPosition: 'header'
    };
    var options = $.extend(_params, settings);
    var createPopupHtml = function() {
      if (options.htmlMarkup)
        return options.htmlMarkup;
      var ckHtml = 
                  '<div id="cp-cookie-popup" class="cookie_popup_wrapper" style="background-color: rgba(255,255,255,0.85); border: none; color: #3F4B65; padding: 24px 10px; position: fixed; bottom: 0; left: 0; right: 0; width: 100%; z-index: 99999; min-height: 50px;">' +
                    '<div class="popup_content_body" style="display: flex; justify-content: center; align-items: center;">' +
                      '<div class="popup_text">' + options.popupText + '</div>' + 
                      '<div class="popup_buttons" style="flex-shrink: 0;">' +
                        '<a href="#" class="popup_button accept_button" style="background-color: #5B98AA; border-radius: 3px; display: inline-block; padding: 8px 18px; font-size: inherit; font-weight: bold; margin-left: 1em;" onmouseover="this.style.color = \'#3F4B65\'" onmouseout="this.style.color = \'#fff\'">' + options.buttonAcceptLabel + '</a>'
                        //  + '<a href="' + options.cookiePolicyUrl + '" class="popup_button read_button">' + options.buttonReadmoreLabel + '</a>' +  
                      '</div>'
                    '</div>'
                  '</div>';
      return ckHtml;
    };
    // Storing the consent in a cookie
    var setUserAcceptsCookies = function(consent) {
      var d = new Date();
      var expiresInDays = options.expiresInDays * 24 * 60 * 60 * 1000;
      d.setTime( d.getTime() + expiresInDays );
      var expires = "expires=" + d.toGMTString();
      document.cookie = COOKIE_NAME + '=' + consent + "; " + expires + ";path=/";
    };

    var userAlreadyAcceptedCookies = function() {
      var userAcceptedCookies = false;
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var c = cookies[i].trim();
        if (c.indexOf(COOKIE_NAME) == 0) {
          userAcceptedCookies = c.substring(COOKIE_NAME.length + 1, c.length);
        }
      }

      return userAcceptedCookies;
    };
    
    var hidePopup = function() {
      $('#cp-cookie-popup').animate({
        opacity: 0,
        height: 0
      }, 200, function() {
        $('#cp-cookie-popup').hide(0);
      });
    };

    var init = function() {
      if (userAlreadyAcceptedCookies())
        return;
      if (INITIALISED)
        return;
      INITIALISED = true;
      var $position = $(options.attachPosition).length ? $(options.attachPosition) : $('footer');
      $position.append(createPopupHtml());
      $('.popup_buttons .accept_button').on('click', function(e) {
        e.preventDefault();
				setUserAcceptsCookies(true);
				hidePopup();
				return false;        
      });
      $('#cp-cookie-popup').show();
    }
    return init();
  }
})(jQuery);

/* * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Function Initialization after page load 
 *
 */
$(function() {

  $("#nav").buildMBNav(); // Initialize Navigation Menu

  // People Search Form
  if ($(".people_field_search").length > 0) {
    $(".people_field_search").buildMHSearch({
      "loadUsedValues": true,
      "loadFormGroup": "peoplesearch"
    });
  }

  // People Search Result Preview
  $('#sr_group_people .sr_bio_list').buildBioPreview();

  // Related People Preview
  $('.landing_wrapper .bio_list, .details_wrapper .bio_list').buildBioPreview();

  // Newsroom landing Jump link
  $('a[href*="#"].news_jump_link').click(function(e) {
    e.preventDefault();
    var target = $(this.hash);
    if (target.length) {
    $('html, body').animate({
      scrollTop: target.offset().top - 130
    }, 600);
    return false;
    }   
  });
  
  /*Newsroom search form */ 
  if($('.search-options .searchForm_section_title').length > 0){
    $('.search-options .searchForm_section_title').on('click',function(){
       if($('.newsroom_landing_wrapper').length > 0){
        $('.minHeightDiv').css('min-height',$('.options_wrapper').height()+425);
       }
      $(this).addClass('active');
      //$('.hm_featured_news_wrapper').invisible();
      $('.options_wrapper').slideDown(); 
      $('.close-options').show().on('click', function(){ 
        $('.options_wrapper').hide();
        $('.close-options').hide();
        //$('.hm_featured_news_wrapper').visible();
        $('.search-options .searchForm_section_title').removeClass('active'); 
        
      });
    });
  }
/* Jquery invisibility function */
jQuery.fn.invisible = function() {
    return this.css('visibility', 'hidden');
};
/*Jquery Visibility function */
jQuery.fn.visible = function() {
    return this.css('visibility', 'visible');
};

  // Careers Landing Dropdown
  $('.careers_landing_wrapper .panel_dropdown').find('.inputSelect select').on('change', function() {
    window.open($(this).val(), "_self");
  });
  if (query) {
    $('.careers_landing_wrapper .panel_dropdown').find('.inputSelect select').betterSelect();
  }


  // Details Page Functions
  $('.details_content').buildMoreLess();
  $('.details_content').buildExpandCollapse();
  $('.side_col_wrapper').buildSideColToggle();

  // Reset table styling
  $('.details_content table').each(function() {
    var borderValue = ($(this).attr('border')) ? $(this).attr('border') : "0";
    var spacingValue = $(this).attr('cellspacing') ? $(this).attr('cellspacing') : "0"; //pixel width between data cells
    var paddingValue = $(this).attr('cellpadding') ? $(this).attr('cellpadding') : "0"; //pixel between cell content and cell border

    if (borderValue !== "0") {
      $(this).css("border", "1px solid #787878");
      $(this).find('td').css("border", borderValue + "px solid #787878");
    }

    if (spacingValue !== "0") {
      $(this).css("border-collapse", "separate").css("border-spacing", spacingValue + "px");
    } else {
      $(this).css("border-collapse", "collapse").css("border-spacing", "0");
    }

    if (paddingValue !== "0") {
      $(this).find('th').css("padding", paddingValue + "px");
      $(this).find('td').css("padding", paddingValue + "px");
    }
  });


  // back to Top Function
  var offset = 500;
  var duration = 500;
  $(window).scroll(function() {
    if (jQuery(this).scrollTop() > offset) {
      $('.back_to_top').fadeIn(duration);
    } else {
      $('.back_to_top').fadeOut(duration);
    }
  });

  $('.back_to_top').click(function(event) {
    event.preventDefault();
    jQuery('html, body').animate({
      scrollTop: 0
    }, duration);
    return false;
  });

  $(document).cpCookiePopup({
    cookiePolicyUrl: '/Cookie-Policy',
    popupText: 'This website uses cookies to record session information in order to remember your choices, save your preferences and provide data for improvement. By continuing to use this site, you consent to the use of cookies.',
    attachPosition: 'footer'
   });

});

$(document).ready(function() {
  $(".printPdf").on('click', function(e) {
      e.preventDefault();
      generatePDF($(location).attr('pathname').substring(1, $(location).attr('pathname').length), "", "");
  });
});

function generatePDF(pagePath, pageRequestVars, urlPrefix) {
  geturl = "/webportal/serveContent.v?src=ajax-pdf-download" + (pagePath ? "&pagePath=" + pagePath : "") + (pageRequestVars ? "&pageRequestVars=" + pageRequestVars : "") + (urlPrefix ? "&urlPrefix=" + urlPrefix : "");
  $.ajax({
      url: geturl
  }).done(function(responseTxt) {
      window.location.href = responseTxt.replace("&amp;", "&");
      return false;
  });
}